import React from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap';
import './CollectionCreators.css'
import UserAutoComplete from '../../form/autocomplete/user/UserAutoComplete';
import ElementHeader from '../../form/ElementHeader';
import { useTranslation } from 'react-i18next';
import { ReactComponent as UserIcon } from '../../utilities/icons/avatar.svg';
import CollectionManagementRight from '../management-rights/CollectionManagementRight';
import Message from '../../form/Message';
import CheckBox from "../../form/CheckBox";

const creatorEquals = (a, b) => {
  if (typeof a === 'string' || typeof b === 'string') {
    return a === b;
  }

  const aFullName = a.displayName;
  const bFullName = `${b.firstName} ${b.lastName}`;
  return a.userName === b.userName && aFullName === bFullName;
};

const CollectionCreators = ({ creators = [], onChange, disabled, isCreatorHidden = '', onVisibilityChange, messages }) => {
  const { t } = useTranslation();
  const checked = Boolean(isCreatorHidden);

  const selectCreators = (creator) => {
    if (!creators.some(c => creatorEquals(c, creator))) {
      const newSelectedCreator = [{ displayName: `${creator.firstName} ${creator.lastName}`, userName: creator.userName }];
      if (onChange) {
        onChange(newSelectedCreator);
      }
    }
  };

  const removeCreator = (creator) => {
    const restOfTheCreators = creators.filter(c => !creatorEquals(c, creator));
    if (onChange) {
      onChange(restOfTheCreators);
    }
  };

  const handleCreatorVisibility = (e) => {
    const nextHide = Boolean(e?.target?.checked);

    if (onVisibilityChange) {
      onVisibilityChange(nextHide);
    }
  };

  return (
    <Container className="collection-creators ps-0">
      <Row className="collection-form-section-publisher-row">
        <Col>
          <ElementHeader label={(t('collection_management_creator_form_header'))} required>
            {t('collection_management_creator_form_header')}
          </ElementHeader>
        </Col>
      </Row>
      <Row>
        <Col>
          <UserAutoComplete onSelect={selectCreators} disabled={disabled} />
        </Col>
      </Row>
      <Row className="mt-0">
        <Col>
          <ul className="collection-management-rights-list">
            {creators.map((creator) =>
              <li key={creator}>
                <CollectionManagementRight label={typeof creator === 'string' ? creator : `${creator.displayName} (${creator.userName})`} onRemove={() => removeCreator(creator)} Icon={UserIcon} disabled={disabled} />
              </li>)}
          </ul>
          <Message type={messages?.type}>{messages?.content}</Message>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="collection-management-creator-checkbox">
            <CheckBox
                checked={checked}
                onChange={handleCreatorVisibility}
                label={t('collection_management_creator_checkbox_label')}
                aria-label={t('collection_management_creator_checkbox_aria_label')}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );

};

CollectionCreators.propTypes = {
  creators: PropTypes.array,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  messages: PropTypes.shape({
    content: PropTypes.string,
    type: PropTypes.oneOf(['light', 'neutral', 'warning'])
  }),
  isCreatorHidden: PropTypes.bool
};

export default CollectionCreators;